var app = globalThis;
globalThis.masterBackoffice = globalThis.masterBackoffice || {};

$(document).on("ready page:load", function()
{
  masterBackoffice.ClipsedNav        = new masterBackoffice.ClipsedNav($('.main-navigation'));
  masterBackoffice.Flash             = new masterBackoffice.Flash($('.flash-container'));
  masterBackoffice.MainLoader        = new masterBackoffice.MainLoader($('#bo-main-loader'));
  masterBackoffice.ImageLibrary      = new masterBackoffice.ImageLibrary();
  masterBackoffice.FontOrdering      = new masterBackoffice.FontOrdering();
  masterBackoffice.FontChangeClass   = new masterBackoffice.FontChangeClass();
  masterBackoffice.LibraryListImages = new masterBackoffice.LibraryListImages();
  masterBackoffice.ImageModalOpener  = new ImageModalOpener();
  masterBackoffice.SearchFilter.initFilters($('input.filter'));
  masterBackoffice.Popover.initPopovers($('.toggle-popover'));

  $('table.bo-table').each(function() { new Tablesort($(this)[0]); });

  app.modalLoader = masterBackoffice.MainLoader;

  $('[data-toggle="dropdown"]').dropdown();

  $('.panel-title').checkboxChecker();

  $('[data-toggle="tooltip"]').tooltip();
  $('.has-popover').popover({html: true});

  // Advanced filters - Start
  $('button.toggle-advanced-search').on('click', function() {
    $('#advanced-search').toggle();
  });
  $('select:disabled').parent().find('input.ui-autocomplete-input').prop('disabled', true);
  $('.form-group label.toggle-filter').on('change', 'input[type=checkbox]', function(e) {
    $(this).closest('.form-group').toggleClass('disabled').find('.filter').find('input, select, textarea').prop('disabled', function(index, oldPropertyValue) {
      var $this = $(this)

      if($this.hasClass('selectize') || $this.closest('.selectize').length) {
        var selectize = $this[0].selectize;

        if(selectize) {
          if(oldPropertyValue) {
            selectize.enable();
            selectize.focus();
          } else {
            selectize.disable();
          }
        }
      } else {
        return !oldPropertyValue;
      }
    }).first().focus();
  });
  // Advanced filters - End

  // Clipboard
  var clipboards = new Clipboard('.clipboard');
  clipboards.on('success', function(e) {
    $(e.trigger).attr('data-original-title', 'Copié !').tooltip('show').blur();
  }).on('error', function(e) {
    $(e.trigger).attr('data-original-title', 'Erreur de copie...').tooltip('show').blur();
  });

  // Custom select
  $('.selectize').selectize({
    searchField: ['text', 'keywords'],
    onInitialize: function() {
      var self = this;
      this.revertSettings.$children.each(function () {
        $.extend(self.options[this.value], $(this).data());
      });
    }
  });

  $(".selectize-tags").each(function() {
    $(this).selectize({
      delimiter: ",",
      persist: false,
      plugins: $(this).data('selectize-plugins'),
      create: function (input) {
        return {
          value: input,
          text: input,
        };
      }
    });
  });

  $(".selectize-removable").selectize({
    searchField: ['text', 'keywords'],
    plugins: ['remove_button'],
    onInitialize: function() {
      var self = this;
      this.revertSettings.$children.each(function () {
        $.extend(self.options[this.value], $(this).data());
      });
    }
  });

  var hash = window.location.hash
  if(hash) {
    $('ul.nav li a').filter(function() { return $(this).attr('href') == hash }).trigger('click');
  }

  $('.btn').on('click', function(){
    if($(this).is(":disabled")) {
      alert("Bouton disabled ! Impossible de l'actionner.");
      return false;
    }
  });
});
